import MenuItem from "./MenuItem";

export default class Menu {
    label: string | undefined;
    name: string | undefined;
    value: string | undefined;
    term_id: number | undefined;
    items: MenuItem[] | undefined;

    constructor(menu: any) {
        Object.assign(this, menu);

        if (this.items) {
            this.items = this.items.map(item => new MenuItem(item));
        }
    }
}
